module.exports = __webpack_public_path__ + "static/media/cat.af6f3b67.svg";